import { format, parse } from 'date-fns';
import { formatDate } from '@/utils';

export enum PeriodLength {
    day = 'day',
    month = 'month',
    year = 'year',
    week = 'week',
    beWeek = 'beWeek'
}

export interface IPeriodShort {
    start: Date;
    end: Date;
}

export interface IPeriod extends IPeriodShort {
    periodLength: PeriodLength;
}

export interface IPeriodStr {
    start: string;
    end: string;
}

export function formatPeriod(period: IPeriodStr): string {
    if (!period) {
        return '';
    }
    const FMT = 'YYYY-MM-DD';
    const startStr = format(parse(period.start), FMT);
    const endStr = format(parse(period.end), FMT);
    return `${startStr}  ~  ${endStr}`;
}
